import { render, staticRenderFns } from "./ErpIntegrationPanel.vue?vue&type=template&id=40a84b5a&scoped=true"
import script from "./ErpIntegrationPanel.vue?vue&type=script&lang=js"
export * from "./ErpIntegrationPanel.vue?vue&type=script&lang=js"
import style0 from "./ErpIntegrationPanel.vue?vue&type=style&index=0&id=40a84b5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a84b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a84b5a')) {
      api.createRecord('40a84b5a', component.options)
    } else {
      api.reload('40a84b5a', component.options)
    }
    module.hot.accept("./ErpIntegrationPanel.vue?vue&type=template&id=40a84b5a&scoped=true", function () {
      api.rerender('40a84b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/ErpIntegrationPanel.vue"
export default component.exports